// extracted by mini-css-extract-plugin
export var image = "cr_b4";